webpackJsonp(["conditioner44"],{

/***/ "./src/js/components/tour.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = tour;
function tour($container, _ref) {
  var initial = _ref.initial,
      $refs = _ref.$refs;

  var currentScene = initial;

  function onClickScene(e) {
    e.preventDefault();
    $refs.frame[0].src = e.currentTarget.getAttribute('data-href');
    window.history.replaceState({}, '', e.currentTarget.href);
    $refs.select[0].value = e.currentTarget.href;

    updateMarker(e.currentTarget.getAttribute('data-title'));
  }

  function updateMarker(scene) {
    $container.querySelector('a[data-title="' + currentScene + '"]').children[1].classList.remove('border-yellow');

    currentScene = scene;

    $container.querySelector('a[data-title="' + currentScene + '"]').children[1].classList.add('border-yellow');
  }

  $refs.scenes.forEach(function ($scene) {
    if ($scene.getAttribute('data-href') === $refs.frame[0].src) {
      window.history.replaceState({}, '', $scene.href);
    }
    $scene.addEventListener('click', onClickScene);
  });

  $refs.select[0].addEventListener('change', function () {
    var $selectedOption = $refs.select[0].options[$refs.select[0].selectedIndex];
    $refs.frame[0].src = $selectedOption.getAttribute('data-href');
    window.history.replaceState({}, '', $selectedOption.value);

    updateMarker($selectedOption.getAttribute('data-title'));
  });

  return function () {
    $refs.scenes.forEach(function ($scene) {
      $scene.removeventListener('click', onClickScene);
    });
  };
}

/***/ })

});


// WEBPACK FOOTER //
// conditioner44.fb588b8df6507e33e008.js